import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";
import { UnitGroupsList } from "@lib/types/unit_group";

export const getUnitGroups = async (): Promise<UnitGroupsList> => {
  const { data } = await axiosClient.get(ENDPOINTS.BASE_UNIT_GROUPS);
  return data;
};
